// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsMenu__root","tippy":"SettingsMenu__tippy","button":"SettingsMenu__button"};
    if(module.hot) {
      // 1790535735129
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  